import store from '../store';
import i18n from '../i18n';
import axios from 'axios';
import jwt from 'json-web-token';
import {API} from "../api";
import {EB as EventBus} from "./bus";
import {Message} from 'element-ui';
import dayjs from "./dayjs";

const EB = EventBus

export async function create_file_from_url(url, filename) {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Could not fetch file from URL: ${response.statusText}`)
  }

  const blob = await response.blob()
  return new File([blob], filename, {
    type: blob.type
  })
}

export function get_base64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })
}

export function random_choice(choices) {
  const index = Math.floor(Math.random() * choices.length)
  return choices[index]
}

export function percent_of(percent, value) {
  return +value * +percent / 100
}

export function is_percent_of(value1, value2, fixed = 1) {
  return +value2 ? +(+value1 * 100 / +value2).toFixed(fixed) : 0
}

export function includes_fixed_shop(shop_id) {
  return store.state.new_campaign_list.includes(shop_id)
}

export function includes_fixed_list(key) {
  return store.state[key] && store.state[key].some(i => store.state.userInfo.username.includes(i))
}

export function scroll_to_top_element(selector) {
  const element = document.querySelector(selector)
  if (element) {
    element.scrollTop = 0
  }
}

export async function copy_text(text, show_message = true) {
  try {
    await navigator.clipboard.writeText(text)

    if (show_message) {
      Message({
        message: i18n.t('base.copied'),
        type: 'success',
        duration: 4000
      })
    }
  } catch (e) {
    console.error(e)
  }
}

export async function copy_object(url, show_message = true) {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    await navigator.clipboard.write([new ClipboardItem({'image/png': blob})])

    if (show_message) {
      Message({
        message: i18n.t('base.copied'),
        type: 'success',
        duration: 4000
      })
    }
  } catch (e) {
    console.error(e)
  }
}

export function format_currency(value, default_zero = true) {
  // return value && !Number.isNaN(+value) ? Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : (defaultZero ? 0 : value)

  if (!value || Number.isNaN(+value)) return default_zero ? 0 : value

  const [integer_part, decimal_part] = Number(value).toFixed(2).split('.')
  const formatted_integer_part = integer_part.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return decimal_part && decimal_part !== '00' ? `${formatted_integer_part}.${decimal_part}` : formatted_integer_part
}

export function format_currency_with_decimal(value, default_zero = true) {
  if (!value || Number.isNaN(+value)) {
    return default_zero ? 0 : value
  }

  const numberString = value.toString();

  const [integerPart, decimalPart] = numberString.split('.')

  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart
}

export function VND(_number) {
  if (!_number) _number = '0'
  if (Number.isNaN(_number)) _number = '0'
  let resString = ''
  let counter = 0
  _number = Math.floor(_number).toString()
  let param = (_number.toString().split('.').join(''))
    .toString()
    .split(',')
    .join('.')
    .split('.')
  let mString = (Math.floor(param[0])).toString()
  for (let i = mString.length - 1; i >= 0; i--) {
    resString = mString[i] + resString
    counter += 1
    if (counter % 3 === 0 && i !== 0 && param[0][i - 1] !== '-') {
      resString = '.' + resString
    }
  }
  return resString
}

export function remove_unicode(value) {
  if (typeof value === 'undefined') {
    return ''
  }
  value = value
    .toString()
    .trim()
    .toLowerCase()

  value = value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');

  return value
}

export const client_api_key = '275MPDfZNjLY2jgY'

export function client_encode_json(data) {
  return new Promise(resolve => {
    let time = Math.floor((new Date()).getTime() / 1000)
    let secret_key = `${client_api_key}_${(Math.floor(time / 10)) + 2020}`
    jwt.encode(secret_key, data, (error, data) => {
      resolve({
        time: time,
        data: data
      })
    })
  })
}

export function client_decode_json(data) {
  return new Promise(resolve => {
    try {
      let time = Math.floor((new Date()).getTime() / 1000)
      let secret_key = `${client_api_key}_${(Math.floor(time / 10)) + 2020}`
      jwt.decode(secret_key, data, (error, data) => {
        resolve({
          time: time,
          data: data
        })
      })
    } catch (e) {
      resolve({})
    }
  })
}

export function cf() {
  if (typeof store.state.userInfo.token == 'undefined') {
    return {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  } else {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': store.state.userInfo.token
      }
    }
  }
}

export const channel_list = [{
  name: 'Shopee',
  value: 'shopee',
  image: 'shopee.png'
}, {
  name: 'Shopee Marketing',
  value: 'shopee_marketing',
  image: 'shopee.png'
}, {
  name: 'Tiki',
  value: 'tiki',
  image: 'tiki.png'
}, {
  name: 'Sendo',
  value: 'sendo',
  image: 'sendo.png'
}, {
  name: 'Lazada',
  value: 'lazada',
  image: 'lazada.png'
}, {
  name: 'Tiktok',
  value: 'tiktok',
  image: 'tiktok.png'
}]

export function logo_channel(channel) {
  let channel_filtered = channel_list.filter(e => e.value === channel)
  return channel_filtered.length > 0 ? `https://static.atosa.asia/logo/${channel_filtered[0].image}` : '/static/img/logo.png'
}


export function get_proxy(shop) {
  if (shop && shop.extra_data && shop.extra_data.proxy) {
    const proxy = shop.extra_data.proxy
    const schema = 'http'
    const username = proxy.proxy_username
    const password = proxy.proxy_password
    const dns = proxy.proxy_server
    const port = Math.floor(proxy.proxy_port)

    return `${schema}://${username}:${password}@${dns}:${port}`
  } else if (shop && shop.extra_data && shop.extra_data.system_proxy) {
    return `system_proxy:${shop.extra_data.system_proxy}`
  }

  return ''
}

export function check_role(shop, feature_code, feature_role, show_ntf = true) {
  // console.log(shop.role_table)
  // console.log(feature_code)
  // console.log(feature_role)

  if (!shop) {
    return false
  }

  if (!shop.is_sub_account || !shop.role_table) {
    return true
  } else {
    const feature = shop.role_table.find(i => i.code === feature_code)
    if (!feature) {
      if (show_ntf) EB.$emit('NTF_warning', i18n.t('sub_accounts.error_feature_not_found'))
      return false
    }

    if (!feature.roles[feature_role]) {
      if (show_ntf) EB.$emit('NTF_warning', i18n.t('sub_accounts.error_feature_not_found'))
      return false
    }

    if (!feature.roles[feature_role].checked) {
      if (show_ntf) EB.$emit('CFM_warning', `${i18n.t('sub_accounts.error_cannot_access')}: ${feature.name} - ${feature.roles[feature_role].name}`)
      return false
    }

    return true
  }
}

export function timeFormat(input, format = 'HH:mm DD/MM/YYYY') {
  // const date = new Date(input)
  // return `${date.getHours()}:${date.getMinutes()} ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

  if (!input) return dayjs().format(format)
  return dayjs(new Date(input)).format(format)
}

export async function execute_browser(script) {
  return await axios.post(`http://127.0.0.1:4567/api/v1/worker/${store.state.worker_id}`, {
    evaluate: script
  })
}

export async function xget_shopee(url, config) {
  const script = `(async() => {
    console.clear();
    return await window.xget('${url}', ${JSON.stringify(config)});
})()`

  const response = await axios.post(`http://127.0.0.1:4567/api/v1/worker/${store.state.worker_id}`, {
    evaluate: script
  })

  axios.post(API.URL_API_SRV_7 + '/shopee/search_items/log', {
    type: 'xget_shopee',
    config: JSON.stringify({
      url,
      config
    }),
    data: response && response.data ? JSON.stringify(response.data) : null
  }, {headers: cf().headers})
    .catch(console.error)

  return response
}

export async function xpost_shopee(url, data, config) {
  const script = `(async() => {
    console.clear();
    return await window.xpost('${url}', ${JSON.stringify(data)}, ${JSON.stringify(config)});
})()`

  const response = await axios.post(`http://127.0.0.1:4567/api/v1/worker/${store.state.worker_id}`, {
    evaluate: script
  })

  axios.post(API.URL_API_SRV_7 + '/shopee/search_items/log', {
    type: 'xpost_shopee',
    config: JSON.stringify({
      url,
      data,
      config
    }),
    data: response && response.data ? JSON.stringify(response.data) : null
  }, {headers: cf().headers})
    .catch(console.error)

  return response
}

export function escape_regex(value, is_trim = true) {
  if (is_trim) {
    return value.toString().trim().replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
  } else {
    return value.toString().replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
  }
}

export function get_value_by_path(obj, path) {
  return path.split('.').reduce((acc, key) => acc ? acc[key] : null, obj)
}

export function is_mobile_device() {
  const user_agent = navigator.userAgent.toLowerCase();
  return /mobile|android|iphone|ipad|ipod/.test(user_agent);
}



// WEBPACK FOOTER //
// ./src/addon/function.js